import ScreenLayout from 'components/common/ScreenLayout';
import React, {useEffect, useState} from 'react';
import styled, {css} from 'styled-components';
import {colors} from 'styles/colors';
import {minmax} from 'utils/minmax';
import DefaultText from 'components/common/DefaultText';
import {useRecoilValue} from 'recoil';
import {userInfoState} from 'utils/Atoms';
import {
  getReferralCodeList,
} from 'function/api';
import ContainerHeader from 'components/common/ContainerHeader';
import {getDevice} from 'utils/getDevice';
import {convertTotalPage} from 'function/converter';
import {formatPhoneNumber} from 'utils/fomatPhoneNumber';
import moment from 'moment';
import Pagination from 'components/common/Pagination';

export default function ReferralCodeList() {
  const [isLoading, setIsLoading] = useState(false);
  const [errorModal, setErrorModal] = useState({});
  const userInfo = useRecoilValue(userInfoState);
  const device = getDevice();

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isUse, setIsUse] = useState(false);
  const [keyword, setKeyword] = useState('');

  const [data, setData] = useState<any>();

  useEffect(() => {
    const asyncFunc = async () => {
      if (userInfo) {
        const result = await getReferralCodeList({
          count: 10,
          page: currentPage,
          isUse,
          keyword,
          userInfo,
          setIsLoading,
          setErrorModal,
        });

        if (result) {
          setData(result.referralCodeList);
          const resTotalPage = convertTotalPage(result.totalCount ?? 0, 10);
          setTotalPage(resTotalPage);
        }
      }
    };
    asyncFunc();
  }, [userInfo, currentPage, isUse]);

  return (
    <ScreenLayout isLoading={isLoading} errorModal={errorModal}>
      <Container>
        <ContainerHeader mainTitle="referralCodeList" />
        <Inner $device={device}>
          <DefaultText
            text="referralCodeList"
            textStyle={{
              fontSize: minmax(25),
              fontWeight: 'bold',
              borderBottom: `3px solid ${colors.primary}`,
              width: 'fit-content',
            }}
          />

          <ResultArea>
            <ResultHeader>
              <DefaultText
                text=""
                textStyle={{
                  ...ResultHeaderTextStyle,
                  flex: 0.4,
                }}
              />
              <DefaultText text="createdAt" textStyle={ResultHeaderTextStyle} />
              <DefaultText text="민료일" textStyle={ResultHeaderTextStyle} />
              <DefaultText text="코드" textStyle={ResultHeaderTextStyle} />
              <DefaultText text="등록" textStyle={{...ResultHeaderTextStyle}} />
              <DefaultText text="폐기" textStyle={{...ResultHeaderTextStyle}} />
            </ResultHeader>

            <ResultList>
              {data?.length ? (
                data.map((item: any, index: number) => (
                  <ResultItem
                    key={item.uuid}
                    onClick={() => {
                      //
                    }}>
                    <DefaultText
                      text={(
                        (currentPage - 1) * 10 +
                        index +
                        1
                      ).toString()}
                      textStyle={{...ResultHeaderTextStyle, flex: 0.4}}
                    />
                    <DefaultText
                      text={moment(item.createdAt).format('YY-MM-DD')}
                      textStyle={ResultItemStyle}
                    />
                    <DefaultText
                      text={moment(item.expiredAt).format('YY-MM-DD')}
                      textStyle={ResultItemStyle}
                    />
                    <DefaultText
                      text={item.code || '-'}
                      textStyle={ResultItemStyle}
                    />
                    <DefaultText
                      text={item.isRegister ? 'O ' : 'X'}
                      textStyle={{...ResultItemStyle}}
                    />
                    <DefaultText
                      text={item.isDiscarded ? 'O ' : 'X'}
                      textStyle={{...ResultItemStyle}}
                    />
                  </ResultItem>
                ))
              ) : (
                <DefaultText
                  text="noDataMsgTongList"
                  textStyle={{
                    color: colors.darkGray,
                    textAlign: 'center',
                    margin: `${minmax(12)} 0`,
                  }}
                />
              )}
            </ResultList>
          </ResultArea>

          {totalPage ? (
            <Pagination
              totalPage={totalPage}
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
            />
          ) : null}
          <div
            style={{
              display: 'flex',
              justifyContent: 'end',
              width: '100%',
            }}>
            {/* <DefaultButton
              text={'register'}
              buttonStyle={{backgroundColor: colors.primary2}}
              textStyle={{color: colors.white}}
            /> */}
          </div>
        </Inner>
      </Container>
    </ScreenLayout>
  );
}

const Container = styled.div`
  display: flex;
  width: 100%;
  flex: 1;
  flex-direction: column;
  margin-bottom: ${minmax(50)};
`;

const Inner = styled.div<{$device?: string}>`
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: ${minmax(40)};
  padding-top: 0;
  gap: ${minmax(40)};

  ${(props: any) =>
    props.$device === 'mobile' &&
    css`
      width: 90%;
      min-width: auto;
    `}
`;

const ResultArea = styled.div`
  margin-bottom: ${minmax(40)};
  border-bottom: 1px solid ${colors.darkGray};
`;

const ResultHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  height: ${minmax(52)};
  background-color: #f7f7f7;
`;

const ResultList = styled.ul`
  /* height: 728px; */
  /* overflow-y: auto; */

  // 스크롤바 삭제
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  &::-webkit-scrollbar {
    display: none; /* Chrome, Safari, Opera*/
  }
`;

const ResultItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: ${minmax(8)} 0;
  min-height: ${minmax(52)};
  border-top: 1px solid ${colors.lightGrey};
  &:last-child {
    border-bottom: none;
  }
`;

const ResultHeaderTextStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  color: '#585858',
};

const ResultItemStyle: React.CSSProperties = {
  flex: 1,
  textAlign: 'center',
  // overflow: 'hidden',
  // textOverflow: 'ellipsis',
  // whiteSpace: 'nowrap',
  // wordBreak: 'break-all',
};
